export default "__VITE_ASSET__1ade8ddf__"